import React from 'react';
import styled from 'styled-components';
import { colors2, Divider, UI_BODY_SM_DF } from 'oolib';
import { useReportConfig } from '../../ReportLandingContext';

const StyledPlaceholderContainer = styled.div`
  padding: 1.4rem;
  display: flex;
  gap: 1.4rem;
  flex-direction: column;
`;

const StyledPlaceholderImageContainer = styled.div`
  width: 100%;
  border-radius: 1.2rem;
  border: 1px solid ${colors2.grey10};
  overflow: hidden;
`;

const StyledPlaceholderSection = styled.div`
  display: flex;
  gap: 0.6rem;
  flex-direction: column;
  /* padding: 1rem 1.6rem; */
  border-radius: 12px;
`;

const StyledPlaceholderText = styled.div`
  color: ${colors2.grey50};
`;

const StyledPlaceholderImage = styled.img`
  width: 100%;
  height: 100%;
`;

const PlaceholderSection = ({ children, imageSrc, altText }) => (
  <StyledPlaceholderSection>
    
    <StyledPlaceholderText>
      <UI_BODY_SM_DF>
        {children}
      </UI_BODY_SM_DF>
    </StyledPlaceholderText>

    {imageSrc && (
      <StyledPlaceholderImageContainer>
        <StyledPlaceholderImage 
          src={imageSrc} 
          alt={altText} 
        />
      </StyledPlaceholderImageContainer>
    )}

  </StyledPlaceholderSection>
);

const placeholderConfigs = {
  edit: {
    text: <><span style={{ fontWeight: "700" }}>Edit</span> a widget to view the widget's options here</>,
    imageSrc: "https://storage.googleapis.com/global-okf-assets/edit.png",
    altText: "Edit widget placeholder"
  },
  addExisting: {
    text: <>To <span style={{ fontWeight: "700" }}>add</span> new widget to an <span style={{ fontWeight: "700" }}>existing</span> section</>,
    imageSrc: "https://storage.googleapis.com/global-okf-assets/edit2.png",
    altText: "Add to existing section placeholder"
  },
  addNew: {
    text: <>To <span style={{ fontWeight: "700" }}>add</span> new widget to a <span style={{ fontWeight: "700" }}>new</span> section</>,
    imageSrc: "https://storage.googleapis.com/global-okf-assets/edit1.png",
    altText: "Add to new section placeholder"
  },
  noWidget: {
    text: <><span style={{ fontWeight: "700" }}>Add</span> a widget to get started</>,
    imageSrc: "https://storage.googleapis.com/global-okf-assets/noWidget.png",
    altText: "No widget placeholder"
  }
};


const PlaceholderSectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
`;

export const FormRendererPlaceholder = () => {
  const { config } = useReportConfig();
  return (
    <StyledPlaceholderContainer>
      {config.length ? (
        <PlaceholderSectionsContainer>

          <PlaceholderSection 
            imageSrc={placeholderConfigs.edit.imageSrc}
            altText={placeholderConfigs.edit.altText}
          >
            {placeholderConfigs.edit.text}
          </PlaceholderSection>
          
          <Divider style={{ margin: "0 -1.4rem" }} />
          
          <PlaceholderSection 
            imageSrc={placeholderConfigs.addExisting.imageSrc}
            altText={placeholderConfigs.addExisting.altText}
          >
            {placeholderConfigs.addExisting.text}
          </PlaceholderSection>
          
          <PlaceholderSection 
            imageSrc={placeholderConfigs.addNew.imageSrc}
            altText={placeholderConfigs.addNew.altText}
          >
            {placeholderConfigs.addNew.text}
          </PlaceholderSection>
          
        </PlaceholderSectionsContainer>

      ) : (
        <PlaceholderSection 
          // imageSrc={placeholderConfigs.noWidget.imageSrc}
          // altText={placeholderConfigs.noWidget.altText}
        >
          {placeholderConfigs.noWidget.text}
        </PlaceholderSection>
      )}
    </StyledPlaceholderContainer>
  );
};